import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { AccountAllocation } from './account-allocation.model';
import { CalcType } from '../../../lookups/CalcType';

export const loadAccountAllocations = createAction(
    '[AccountAllocation/API] Load AccountAllocations',
    props<{ accountAllocations: AccountAllocation[] }>()
);

export const addAccountAllocation = createAction(
    '[AccountAllocation/API] Add AccountAllocation',
    props<{ accountAllocation: AccountAllocation }>()
);

export const upsertAccountAllocation = createAction(
    '[AccountAllocation/API] Upsert AccountAllocation',
    props<{ accountAllocation: AccountAllocation }>()
);

export const addAccountAllocations = createAction(
    '[AccountAllocation/API] Add AccountAllocations',
    props<{ accountAllocations: AccountAllocation[] }>()
);

export const upsertAccountAllocations = createAction(
    '[AccountAllocation/API] Upsert AccountAllocations',
    props<{ accountAllocations: AccountAllocation[] }>()
);

export const updateAccountAllocation = createAction(
    '[AccountAllocation/API] Update AccountAllocation',
    props<{ accountAllocation: Update<AccountAllocation> }>()
);

export const updateAccountAllocations = createAction(
    '[AccountAllocation/API] Update AccountAllocations',
    props<{ accountAllocations: Update<AccountAllocation>[] }>()
);

export const deleteAccountAllocation = createAction(
    '[AccountAllocation/API] Delete AccountAllocation',
    props<{ id: string }>()
);

export const deleteAccountAllocations = createAction(
    '[AccountAllocation/API] Delete AccountAllocations',
    props<{ ids: string[] }>()
);

export const clearAccountAllocations = createAction(
    '[AccountAllocation/API] Clear AccountAllocations'
);
export const getAccountAllocations = createAction(
    '[AccountAllocation/API] Get AccountAllocations'
);
export const putAccountAllocations = createAction(
    '[AccountAllocation/API] Put AccountAllocation',
    props<{ accountAllocations: AccountAllocation[] }>()
);
export const getExpenseTypes = createAction(
    '[AccountAllocation/API] Get Expense Types'
);
export const loadExpenseTypes = createAction(
    '[AccountAllocation/API] Load Expense Types',
    props<{ expenseTypes: CalcType[] }>()
);
